import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import WorkshopsRegular from '@/components/WorkshopsRegular'
import WorkshopsCourses from '@/components/WorkshopsCourses'
import WorkshopsBespoke from '@/components/WorkshopsBespoke'
import WorkshopsStrategy from '@/components/WorkshopsStrategy'
import WorkshopsPlaytotype from '@/components/WorkshopsPlaytotype'
import WorkshopsExperiential from '@/components/WorkshopsExperiential'
// import PlacesAroundHato from '@/components/PlacesAroundHato'
import ChristmasWorkshops from '@/components/ChristmasWorkshops'
import ChristmasCampaign from '@/components/ChristmasCampaign'

// import Graphql from '@/components/Graphql'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    // {
    //   path: '/graphql',
    //   name: 'Graphql',
    //   component: Graphql
    // },
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: '',
          component: WorkshopsRegular
        },
        {
          path: 'courses',
          component: WorkshopsCourses
        },
        {
          path: 'private',
          component: WorkshopsBespoke,
          redirect: 'play'
        },
        {
          path: 'strategy',
          component: WorkshopsStrategy
        },
        {
          path: 'playtotype-offerings',
          component: WorkshopsPlaytotype
        },
        {
          path: 'playtotype',
          component: WorkshopsExperiential
        },
        {
          path: 'play',
          redirect: 'playtotype'
        },
        {
          path: 'bespoke',
          redirect: 'playtotype'
        },
        {
          path: 'christmas',
          name: 'Christmas',
          component: ChristmasWorkshops
        },
        {
          path: 'c',
          name: 'Christmas Campaign',
          component: ChristmasCampaign
        }
      ]
    },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to, from, savedPosition) {
    // console.log('scrollBehavior', to, from, savedPosition)
    if (savedPosition) {
      // return savedPosition
      return { x: 0, y: 0 }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js